/**
 * IndexedDB / browser-API failures that must not surface as user toasts.
 * Prefer this over bare `console.error` so call sites stay greppable.
 */
export function silentError(context: string, err: unknown): void {
  console.error(`[silent:${context}]`, err)
}
